import React, { useEffect } from "react";

/**
 * Web YouTube player — real iframe, no react-native-webview.
 */
export default function YoutubePlayer({
  videoId,
  height = 220,
  width = "100%",
  play = false,
  onReady,
  onError,
}) {
  useEffect(() => {
    if (videoId && onReady) onReady();
  }, [videoId, onReady]);

  if (!videoId) {
    onError?.("missing_video");
    return null;
  }

  const src = `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?playsinline=1&rel=0&modestbranding=1&controls=1${
    play ? "&autoplay=1" : ""
  }`;

  return (
    <iframe
      title="YouTube"
      src={src}
      width={typeof width === "number" ? width : "100%"}
      height={height}
      style={{ border: 0, displayRadius: 12, maxWidth: "100%", background: "#000" }}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      allowFullScreen
      referrerPolicy="strict-origin-when-cross-origin"
    />
  );
}
